var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lby-uploaded-images"},[_c('div',{staticClass:"lby-uploaded-image",on:{"click":_vm.zoomIn}},[_c('img',{ref:"me",attrs:{"src":_vm.src}}),(_vm.showDel)?_c('div',{staticClass:"lby-uploaded-image-del",on:{"click":function($event){$event.stopPropagation();return _vm.delImage(_vm.src)}}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }